Vue.component('group-overview', {
	props: ['group_team', 'selection_active', 'is_selected', 'team_to_location'],

	data() {
		return {
			active_source: null,
			isSelected: false
		}
	},
	
	mounted() {
		this.$on('setGroupOverviewActiveSource', (newSource) => this.updateSource(newSource))
	},

	methods: {
		select() {

			if (! this.selection_active) {
				return
			}

			this.$eventHub.$emit('toggleTeamForComparison', this.group_team.team_id, ! this.is_selected)

		},
		updateSource(source) {
			this.active_source = source
		},
		showNotResponded(kind) {
			let params = this.getOriginalReviewFilters()
			params.responseFilter = 'needResponse'

			if (kind == 'important') {
				params.importance = 'high'
			}

			analytics.track("Opened Group Unresponded Reviews", {
				kind: kind
			})

			this.$eventHub.$emit('updateAndOpenModal', this.group_team.team_id, params)
		}
	}
})